
import React, { Component } from 'react';
import './Scholarship.css';

class Scholarship extends Component {
  render() {
    return (
      <div className="card border-dark mb-3">
        <div className="card-header" style={{ backgroundColor: "#ffcd8E" }}>
          <h2><span className="fa fa-check-square-o  fa-lg"></span>Scholarships</h2>
        </div>
        <div className="card-body" style={{ paddingBottom: "0" }}>
          <h5 className="card-title" style={{ marginLeft: "26px" }}>All Scholarships were provided by TGIST, NECTEC, NSTDA and KMUTT.</h5>
          <table className="table table-sm">
            <tbody>
              <tr className="">
                <td><span className="fa fa-check-square-o  fa-sm"></span><b>Post-doctoral Fellowships. </b> National Electronics and Computer Technology Center (NECTEC), National Science and Technology Development Agency (NSTDA), 2012-2013</td>
              </tr>
              <tr className="">
                <td><span className="fa fa-check-square-o  fa-sm"></span><b>Overseas Research Scholarships (Institute for Infocomm Research, Singapore)  </b> National Electronics and Computer Technology Center (NECTEC), National Science and Technology Development Agency (NSTDA), 2009-2010</td>
              </tr>
              <tr className="">
                <td><span className="fa fa-check-square-o  fa-sm"></span><b>Ph.D. Degree Scholarships. </b> Thailand Graduate Institute of Science and Technology (TGIST), National Science and Technology Development Agency (NSTDA), 2009-2012</td>
              </tr>
              <tr className="">
                <td><span className="fa fa-check-square-o  fa-sm"></span><b>Master Degree Scholarships. </b> Thailand Graduate Institute of Science and Technology (TGIST), National Science and Technology Development Agency (NSTDA), 2008-2009</td>
              </tr>
              </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default Scholarship;

